import { Component, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy } from '@angular/core';

@Component({
	selector: 'app-remove-files-confirm-dialog',
	standalone: true,
	imports: [CommonModule, MatDialogModule, MatButtonModule],
	template: `
		<div mat-dialog-content>Czy na pewno chcesz usunąć ten plik?</div>

		<div mat-dialog-actions align="end">
			<button mat-raised-button color="primary" (click)="close(false)">NIE</button>
			<button mat-raised-button color="warn" (click)="close(true)">TAK</button>
		</div>
	`,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RemoveFilesConfirmDialogComponent {
	private readonly dialogRef = inject(MatDialogRef<RemoveFilesConfirmDialogComponent>);

	close(shouldRemove: boolean): void {
		this.dialogRef.close(shouldRemove);
	}
}
